const Backbone = require('backbone');
const Criteria = require('models/OrderFilterCriteria');

const CriteriaCollection = Backbone.Collection.extend({
  idAttribute: 'FilterCriteriaID',
  model: Criteria,
});

export default CriteriaCollection;
